import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import language from "./language";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        buildings: [],
        availabilities: {},
        states: [],
        contacts: [],
        buildingSearch: '',
        buildingsInit: false
    },
    getters: {
        buildingSearch(state) {
            return state.buildingSearch
        },
        getBuildings(state) {
            return state.buildings
        },
        getAvailabilities(state) {
            return state.availabilities
        },
        getContacts(state) {
            return state.contacts
        }
    },
    mutations: {
        storeBuildingSearch(state, search) {
            state.buildingSearch = search
        },
        setBuildings(state, buildings) {
            Object.assign(state.buildings, buildings)
        },
        setAvailabilities(state, availabilities) {
            state.availabilities = availabilities;
        },
        setStates(state, states) {
            state.states = states;
        },
        setContacts(state, contacts) {
            state.contacts = contacts;
        },
        addBuilding(state, building) {
            state.buildings.push(building)
        },
        replaceBuilding(state, building) {
            state.buildings.splice(state.buildings.findIndex((i) => {
                return i.uuid === building.uuid;
            }), 1, building)
        },
        replaceBuildingData(state, building) {
            state.buildings.splice(state.buildings.findIndex((i) => {
                return i.uuid === building.uuid;
            }), 1, building.address)
        }
    },
    actions: {
        updateBuilding(context, building) {
            axios.put('/address-contact/api/building/' + building.uuid + '/', building)
                .then(response => {
                    context.commit('replaceBuilding', response.data);
                    context.dispatch('mergeBuildingsAndStates')
                })
        },
        updateData(context, building) {
            axios.put('/address-contact/api/building/' + building.uuid + '/', building)
                .then(response => {
                    context.commit('replaceBuildingData', response.data);
                })
        },
        createBuilding(context, building) {
            axios.post('/address-contact/api/building/', building)
                .then(response => {
                    context.commit('addBuilding', response.data);
                })
        },
        loadBuildings(context) {
            axios.get('/address-contact/api/building/')
                .then(response => {
                    context.commit('setBuildings', response.data);
                    context.dispatch('loadStates');
                }).finally(() => {
                    context.dispatch('loadAvailabilities');
                });
        },
        loadAvailabilities(context) {
            axios.post('/legacy-m2m/api/availability/', context.state.buildings.map(building => building.uuid))
                .then(response => {
                    context.commit('setAvailabilities', response.data);
                    context.dispatch('mergeBuildingsAndAvailabilities');
                });
        },
        loadContacts(context) {
            axios.get('/address-contact/api/contact/')
                .then(response => {
                    context.commit('setContacts', response.data)
                })
        },
        loadStates(context) {
            axios.get('/current-state/api/bvh/')
                .then(response => {
                    context.commit('setStates', response.data);
                    context.dispatch('mergeBuildingsAndStates')
                })
        },
        mergeBuildingsAndStates({state, commit}) {
            let tmp = state.buildings;
            tmp.forEach(b => {
                let s = state.states.find(i => i.buildingUuid === b.uuid);
                if (typeof s != "undefined") {
                    b.lastMessage = s.lastMessage;
                    b.state = s.state;
                    b.lastFault = s.lastFault;
                    tmp.splice(tmp.findIndex((i) => {
                        return i.uuid === b.uuid;
                    }), 1, b)
                }
            });
            commit('setBuildings', tmp)
        },
        mergeBuildingsAndAvailabilities({state, commit}) {
            let tmp = state.buildings;
            tmp.forEach(b => {
                let s = state.availabilities[b.uuid];
                if (typeof s != "undefined") {
                    b.availability = s.available_percent;
                    tmp.splice(tmp.findIndex((i) => {
                        return i.uuid === b.uuid;
                    }), 1, b)
                }
            });
            commit('setBuildings', tmp)
        }
    },
    modules: {
        language
    }
})
